import internationality from './internationality.vue'
export default internationality
